import { z } from 'zod';

// Zod schema for receipt validation
export const receiptSchema = z.object({
  merchant_name: z.string().trim().min(1, "Merchant name is required").max(200),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
  total: z.number().min(0, "Total must be positive").max(1000000, "Total is too large"),
  amount: z.number().min(0, "Amount must be positive").max(1000000, "Amount is too large"),
  category: z.string().trim().min(1, "Category is required").max(100),
  tax_savings_estimate: z.number().min(0).max(1000000).optional(),
  subtotal: z.number().min(0).max(1000000).optional(),
  tax: z.number().min(0).max(1000000).optional(),
  currency: z.string().length(3).optional(),
});

export const batchReceiptSchema = z.object({
  merchant: z.string().trim().min(1, "Merchant name is required").max(200),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
  total: z.number().min(0, "Total must be positive").max(1000000, "Total is too large"),
  category: z.string().trim().min(1, "Category is required").max(100),
});

// Validate receipt data before insert/update
export function validateReceiptData(data: any): { success: boolean; error?: string } {
  try {
    receiptSchema.parse(data);
    return { success: true };
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      return { success: false, error: error.errors[0].message };
    }
    return { success: false, error: "Invalid receipt data" };
  }
}

export function validateBatchReceipt(data: any): { success: boolean; error?: string } {
  try {
    batchReceiptSchema.parse(data);
    return { success: true };
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      return { success: false, error: error.errors[0].message };
    }
    return { success: false, error: "Invalid receipt data" };
  }
}

// Validate that file path belongs to user
export function validateUserFilePath(filePath: string, userId: string): boolean {
  return filePath.startsWith(`${userId}/`);
}
